<section class="ecb-x-admin-list-section">

    <div class="container-fluid">

        <div class="ecb-x-admin-list-card">
            <header class="topbar">
                <div>
                    <div class="eyebrow">ECB TRAINING · VETENROL</div>
                    <h1>URL Sync Control Centre</h1>
                    <p>Manage course URLs, control execution order, and watch scraping progress live.</p>
                </div>
                <div class="live"><span></span> Live updates</div>
            </header>

            <section class="hero-grid">
                <div class="panel add-panel">
                    <div class="panel-title">
                        <div>
                            <h2>Add VETEnrol links</h2>
                            <p>Paste one or more links. Use one link per line or separate links with commas.</p>
                        </div>

                        <span class="step">01</span>
                    </div>

                    <form [formGroup]="form" (ngSubmit)="add()">

                        <label class="field-label" for="urls">
                            VETEnrol URL(s)
                        </label>

                        <div style="margin-bottom: 8px; color: #64748b; font-size: 13px;">
                            Example:
                            <span style="color: #2563eb; font-weight: 600;">
                                https://enrol.vetenrol.com.au/?clientid=VT-ECB&amp;progid=1209
                            </span>
                        </div>

                        <textarea id="urls" rows="5" formControlName="urls" placeholder="Enter VETEnrol URL(s) here..."
                            [class.invalid]="form.get('urls')?.touched && form.get('urls')?.invalid">
        </textarea>

                        <small class="validation-error" *ngIf="getUrlValidationMessage()">
                            {{getUrlValidationMessage()}}
                        </small>

                        <div class="form-row">

                            <label>
                                Priority

                                <input type="number" formControlName="priority" min="1" max="9999"
                                    [class.invalid]="form.get('priority')?.touched && form.get('priority')?.invalid">

                                <small class="validation-error"
                                    *ngIf="form.get('priority')?.touched && form.get('priority')?.invalid">
                                    Priority must be between 1 and 9999.
                                </small>
                            </label>

                            <button class="btn primary" type="submit" [disabled]="adding">

                                {{adding ? 'Adding…' : 'Add links'}}

                            </button>

                        </div>

                    </form>

                    <div class="notice" *ngIf="notice">
                        {{notice}}
                    </div>
                </div>

                <div class="panel stats">
                    <div class="stat">
                        <b>{{sources.length}}</b>
                        <span>Total links</span>
                    </div>
                    <div class="stat">
                        <b>{{activeCount}}</b>
                        <span>Active</span>
                    </div>
                    <div class="stat">
                        <b>{{selectedCount}}</b>
                        <span>Selected</span>
                    </div>

                    <div class="actions">
                        <button class="btn secondary" type="button" (click)="runSelected()" [disabled]="!selectedCount">
                            Run selected first
                        </button>
                        <button class="btn primary" type="button" (click)="runAll()" [disabled]="activeCount === 0">
                            Run all active
                        </button>
                    </div>
                </div>
            </section>

            <section class="panel table-panel">
                <div class="table-head">
                    <div>
                        <h2>Configured course links</h2>
                        <p>
                            Each completed link synchronizes Course → Occurrences → Classes → Units and removes stale
                            occurrences for that course only.
                        </p>
                    </div>
                    <div class="search_group">

                        <div class="ecb-x-admin-search-wrapper">

                            <i class="bi bi-search"></i>

                            <input type="search" class="form-control" [(ngModel)]="searchText"
                                (ngModelChange)="onSearchChange()" placeholder="Search name or code"
                                aria-label="Search short courses by name or code">

                        </div>

                        <button type="button" class="ecb-x-admin-add-button" (click)="onSearchChange()">

                            <i class="bi bi-search"></i>

                        </button>

                    </div>

                    <button class="icon-btn" type="button" (click)="load2()">↻ Refresh</button>
                </div>

                <div class="empty" *ngIf="loading">Loading sync sources…</div>

                <ng-container *ngIf="!loading">
                    <div class="empty" *ngIf="sources.length === 0">
                        No course links have been configured yet.
                    </div>

                    <div class="table-wrap" *ngIf="sources.length > 0">
                        <table>
                            <thead>
                                <tr>
                                    <th>
                                        <input type="checkbox" [checked]="allPageSelected" (change)="selectAll()"
                                            title="Select active rows on this page">
                                    </th>
                                    <th>Course / URL</th>
                                    <th>Program</th>
                                    <th>Status</th>
                                    <th>Data synced</th>
                                    <th>Last success</th>
                                    <th>Enabled</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let s of pagedSources">
                                    <td>
                                        <input type="checkbox" [checked]="selected.has(s.id)" [disabled]="!s.isActive"
                                            (change)="toggleSelection(s.id)">
                                    </td>
                                    <td class="course">
                                        <strong>{{s.courseTitle || 'Course title resolves on first run'}}</strong>
                                        <small>{{s.courseCode || 'Pending course code'}}</small>
                                        <a [href]="s.url" target="_blank" rel="noopener noreferrer">{{s.url}}</a>
                                    </td>
                                    <td>
                                        <span class="program">#{{s.programId || '—'}}</span>
                                        <small class="priority">Priority {{s.priority}}</small>
                                    </td>
                                    <td>
                                        <span [class]="statusClass(s.status)">
                                            <i></i>{{s.status}}
                                        </span>
                                        <small class="message">{{s.statusMessage || 'Ready'}}</small>
                                    </td>
                                    <td>
                                        <div class="counts">
                                            <span><b>{{s.lastOccurrenceCount}}</b> Occ.</span>
                                            <span><b>{{s.lastClassCount}}</b> Classes</span>
                                            <span><b>{{s.lastUnitCount}}</b> Units</span>
                                        </div>
                                    </td>
                                    <td>
                                        {{s.lastSuccessUtc ? (s.lastSuccessUtc | date:'medium') : 'Never'}}
                                    </td>
                                    <td>
                                        <button class="switch" type="button" [class.on]="s.isActive"
                                            [attr.aria-label]="s.isActive ? 'Disable source' : 'Enable source'"
                                            (click)="toggleActive(s)">
                                            <span></span>
                                        </button>
                                    </td>
                                    <td>
                                        <div class="row-actions">
                                            <button type="button" (click)="openEdit(s)">Edit</button>
                                            <button type="button" (click)="runOne(s.id)"
                                                [disabled]="!s.isActive">Run</button>
                                            <button type="button" class="danger" (click)="remove(s)"
                                                [disabled]="deletingSourceId !== null">
                                                Delete
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="pagination" *ngIf="sources.length > 0">
                        <div class="pagination-summary">
                            Showing {{pageStart}}-{{pageEnd}} of {{totalRecords}} links
                        </div>

                        <div class="page-size">
                            <label for="pageSize">Rows per page</label>
                            <select id="pageSize" [value]="pageSize"
                                [(ngModel)]="pageSize"  (change)="changePageSize($any($event.target).value)">
                                <option *ngFor="let option of pageSizeOptions" [value]="option">{{option}}</option>
                            </select>
                        </div>

                        <div class="page-controls">
                            <button type="button" (click)="changePage(currentPage - 1)" [disabled]="currentPage === 1">
                                Previous
                            </button>

                            <button type="button" *ngFor="let page of pageNumbers" [class.active]="page === currentPage"
                                (click)="changePage(page)">
                                {{page}}
                            </button>

                            <button type="button" (click)="changePage(currentPage + 1)"
                                [disabled]="currentPage === totalPages">
                                Next
                            </button>
                        </div>
                    </div>
                </ng-container>
            </section>
        </div>
    </div>
</section>

<!-- ============================================================
     Delete configured VETEnrol source confirmation
     ============================================================ -->
<div class="manual-delete-backdrop" *ngIf="pendingDeleteSource" (click)="closeDeletePopup()">

    <div class="manual-delete-dialog" (click)="$event.stopPropagation()">

        <div class="manual-delete-icon">
            <i class="bi bi-trash3"></i>
        </div>

        <div class="manual-delete-content">

            <span class="manual-delete-eyebrow">
                DELETE SYNC SOURCE
            </span>

            <h2>
                Remove this configured VETEnrol link?
            </h2>

            <div class="manual-delete-source" *ngIf="pendingDeleteSource">

                <strong>
                    {{
                    pendingDeleteSource.courseCode ||
                    ('Program #' + (pendingDeleteSource.programId || '—'))
                    }}
                </strong>

                <span>
                    {{
                    pendingDeleteSource.courseTitle ||
                    'Course title not resolved yet'
                    }}
                </span>

                <small>
                    {{ pendingDeleteSource.url }}
                </small>

            </div>

            <p>
                This removes the configured Manual Sync source.
                The source will no longer be available for future synchronization.
            </p>

            <div class="manual-delete-warning">
                <i class="bi bi-exclamation-triangle-fill"></i>
                <span>This action cannot be undone.</span>
            </div>

            <div class="manual-delete-error" *ngIf="deleteNotice">

                <i class="bi bi-exclamation-circle-fill"></i>

                <span>
                    {{ deleteNotice }}
                </span>

            </div>

        </div>

        <div class="manual-delete-actions">

            <button type="button" class="btn secondary" [disabled]="deletingSourceId !== null"
                (click)="closeDeletePopup()">

                Cancel

            </button>

            <button type="button" class="btn manual-delete-confirm" [disabled]="deletingSourceId !== null"
                (click)="confirmDeleteSource()">

                <span class="spinner-border spinner-border-sm" *ngIf="deletingSourceId !== null">
                </span>

                <i class="bi bi-trash3" *ngIf="deletingSourceId === null">
                </i>

                {{
                deletingSourceId !== null
                ? 'Deleting…'
                : 'Delete Source'
                }}

            </button>

        </div>

    </div>

</div>

<!-- ============================================================
     Edit existing VETEnrol sync source
     ============================================================ -->
<div class="edit-source-backdrop" *ngIf="editingSource" (click)="closeEdit()">
    <div class="edit-source-dialog" (click)="$event.stopPropagation()">
        <div class="edit-source-header">
            <div>
                <span class="edit-source-eyebrow">EDIT SYNC SOURCE</span>
                <h2>{{editingSource.courseTitle || editingSource.courseCode || 'VETEnrol source'}}</h2>
                <p>
                    Edit the URL or course metadata, then save and run to refresh the same linked short course.
                </p>
            </div>

            <button type="button" class="edit-source-close" (click)="closeEdit()" [disabled]="savingEdit">
                ×
            </button>
        </div>

        <form [formGroup]="editForm" (ngSubmit)="saveEdit(false)">
            <div class="edit-source-body">

                <div class="edit-source-info">
                    <strong>Existing course link</strong>
                    <span>
                        Course ID: {{editingSource.linkedCourseId || 'resolves on next run'}}
                        · Current Program: #{{editingSource.programId || '—'}}
                    </span>
                    <small>
                        Keeping the same course code or progid on this row is allowed.
                        A value already used by another source/course is blocked.
                    </small>
                </div>

                <label class="edit-full">
                    VETEnrol URL
                    <input type="text" formControlName="url"
                        [class.invalid]="editForm.get('url')?.touched && editForm.get('url')?.invalid"
                        placeholder="https://enrol.vetenrol.com.au/?clientid=VT-ECB&amp;progid=1209">

                    <small class="validation-error" *ngIf="getEditUrlValidationMessage()">
                        {{getEditUrlValidationMessage()}}
                    </small>
                </label>

                <div class="edit-source-grid">
                    <label>
                        Course code
                        <input type="text" formControlName="courseCode" maxlength="200"
                            placeholder="e.g. ALT - (HLTAID011)">
                        <small>
                            This is the current/expected code. The run updates it to the code resolved from VETEnrol.
                        </small>
                    </label>

                    <label>
                        Course title
                        <input type="text" formControlName="courseTitle" maxlength="500"
                            placeholder="Current course title">
                        <small>
                            The next successful run replaces this with the VETEnrol title.
                        </small>
                    </label>

                    <label>
                        Category
                        <input type="text" formControlName="category" maxlength="200">
                    </label>

                    <label>
                        Priority
                        <input type="number" formControlName="priority" min="1" max="9999"
                            [class.invalid]="editForm.get('priority')?.touched && editForm.get('priority')?.invalid">
                    </label>
                </div>

                <label class="edit-enabled">
                    <input type="checkbox" formControlName="isActive">
                    <span>
                        <strong>Enabled</strong>
                        <small>Only enabled sources can be queued for synchronization.</small>
                    </span>
                </label>

                <div class="edit-source-notice" *ngIf="editNotice">
                    {{editNotice}}
                </div>
            </div>

            <div class="edit-source-footer">
                <button type="button" class="btn secondary" (click)="closeEdit()" [disabled]="savingEdit">
                    Cancel
                </button>

                <button type="submit" class="btn secondary" [disabled]="savingEdit">
                    {{savingEdit ? 'Saving…' : 'Save'}}
                </button>

                <button type="button" class="btn primary" (click)="saveEdit(true)" [disabled]="savingEdit">
                    {{savingEdit ? 'Saving…' : 'Save & Run'}}
                </button>
            </div>
        </form>
    </div>
</div>